export default {
    commentInteraction: function ($, sukoaUtils) {
        let displayForm = () => {
            let href = sukoaUtils.getCurrentURL(true);
            href += "?display_comment_form=true&ck=" + new Date().getTime();
            $.get(href, function (data) {
                let newForm = $("<div>" + data + "</div>").find("#comment-wrapper-outer .form-wrapper");
                let currentWrapper = $("#comment-wrapper-outer");
                let currentFormWrapper = currentWrapper.find(".form-wrapper");
                currentFormWrapper.html(newForm.html());
            });
        };
        displayForm();
        //highlightin the comment
        let commentID = sukoaUtils.getParameterByName("highlightcomment");
        if (commentID != null && commentID.length > 0) {
            let target = $("#" + commentID);
            if (target.length > 0) {
                target.addClass("highlight-new");
                $('html,body').animate({scrollTop: target.offset().top - 60}, 500);
            }
        }

        let commentWrapperOuter = $("#comment-wrapper-outer");
        let commentWrapper = $("#comments-wrapper");

        let newCommentWrapper = $("#new_comment_wrapper");
        let newCommentButton = $("#new_comment_wrapper #new_comment");

        commentWrapper.on("click", ".comment_reply", function (e) {
            e.preventDefault();
            let b = $(this);
            let commentId = $(this).parent().attr("id");
            b.parent().append(commentWrapperOuter.find(".form-wrapper"));
            $("#replyto").val(commentId);
            $(newCommentButton).show();
            newCommentWrapper.find(".content_wrapper").hide();
        });
        commentWrapper.on("change", ".comment-state-select", function () {
            let commentstate = $(this).val();
            let commentDiv = $(this).closest(".comment-entry");
            let commentId = commentDiv.attr("id");
            commentDiv.removeClass("comment-submitted comment-enabled comment-disabled").addClass("comment-" + commentstate);
            $.get(window.location.pathname + "?changeCommentState=" + commentstate + "&commentId=" + commentId);
        });
        commentWrapper.on("click", ".delete-comment", function (e) {
            let commentDiv = $(this).closest(".comment-entry");
            let childrenDivs = "";
            let commentId = commentDiv.attr("id");
            let childrenCount = commentDiv.attr("data-children-count");
            let dialogText = "Diesen Kommentar ";
            if (childrenCount != "0") {
                dialogText += "\ninklusive " + childrenCount + " Antworten\n";
                childrenDivs = commentDiv.nextUntil(".level-1");
                childrenDivs.addClass("to-delete");
            }
            commentDiv.addClass("to-delete");
            dialogText += "defintiv löschen?";
            window.setTimeout(function () {
                if (confirm(dialogText)) {
                    $.get(window.location.pathname + "?deleteCommentId=" + commentId, function (data) {
                        commentDiv.fadeOut(300);
                        if (childrenCount != "0") {
                            childrenDivs.fadeOut(100);
                        }
                    });
                } else {
                    commentDiv.removeClass("to-delete");
                    if (childrenCount != "0") {
                        childrenDivs.removeClass("to-delete");
                    }
                }
            }, 50);
        });

        newCommentWrapper.on("click", "#new_comment", function () {
            $(newCommentWrapper).find(".content_wrapper").append(commentWrapperOuter.find(".form-wrapper"));
            $("#replyto").val("");
            newCommentWrapper.find(".content_wrapper").slideDown();
            $(this).hide();
        });

        newCommentWrapper.on("click", "#close_new_comment", function () {
            newCommentWrapper.find(".content_wrapper").slideUp();
            $(newCommentButton).show();
        });
    }
};
